/** Роли пользователей. Клиент видит только свои заявки, оператор и админ работают в админке. */
export const USER_ROLES = ['client', 'operator', 'admin'] as const
export type UserRole = (typeof USER_ROLES)[number]

export function isStaff(role: UserRole): boolean {
  return role === 'operator' || role === 'admin'
}
